// 仪器管理路由
import Layout from "@/layout";

const systemRoute = [
  {
    path: "/systemManagement",
    component: Layout,
    name: "systemManagement",
    meta: {
      title: "系统设置",
      roles: ["ROLE_ADMIN"]
    },
    children: [
      {
        path: "menu-management",
        component: () => import("@/views/systemManagement/menuManagement"),
        name: "menuManagementIndex",
        meta: {
          title: "菜单管理",
          icon: "userRole"
        }
      },
      {
        path: "role",
        component: () => import("@/views/personManagement/role"),
        name: "personRole",
        meta: {
          title: "角色管理",
          icon: "employee"
        }
      },
      {
        path: "authority-management/:id",
        component: () => import("@/views/systemManagement/authorityManagement"),
        name: "authorityManagementIndex",
        meta: {
          title: "权限管理",
          icon: "userRole"
        },
        hidden: true
      }
    ]
  }
];
export default systemRoute;



// WEBPACK FOOTER //
// ./src/router/modules/system.js